// extracted by mini-css-extract-plugin
module.exports = {"contact-form":"ContactForm_contact-form__2H_yu"};